export default __webpack_public_path__ + "static/media/img-gnb-men-on.b4c7ad98.svg";